class Slider {

  constructor() {
    this.listeners();
  }

  listeners() {
    const sliders = document.querySelectorAll('.js-slider');

    sliders.forEach((el) => {
      this.createSlider(el);
    });

    document.addEventListener('blogCarouselSlider:ready', (e) => {
      const slider = document.getElementById(e.detail.id);

      if (!slider) return;

      this.createSlider(slider);
    });

    document.addEventListener('accordionSlider:ready', (e) => {
      const sliders = document.querySelectorAll(e.detail.sliderSelector);

      sliders.forEach((slider) => {
        this.createSlider(slider);
      })
    });

    document.addEventListener('asyncSlider:ready', () => {
      const asyncSliders = document.querySelectorAll('.js-async-slider');

      asyncSliders.forEach((el) => {
        this.createSlider(el);
      })
    });
  }

  createSlider(el) {
    const sliderId = el.id;
    let primarySlider;
    let secondarySlider;
    let sliderNav;
    let thumbnails;
    let navButtons = null;

    const slider = document.querySelector(`#${sliderId}`);
    const pagination = slider.querySelector('.js-slider-pagination');
    const progressBar = slider.querySelector('.js-slider-progress-bar');
    const page = slider.querySelector('.js-slider-page');

    if (el.getAttribute('data-slider-sync-to')){
      sliderNav = document.querySelector(el.getAttribute('data-slider-sync-to'));
      secondarySlider = new Splide(sliderNav, this.configuration(sliderNav));
      primarySlider = new Splide(el, this.configuration(el));
      primarySlider.sync( secondarySlider );
    } else {
      primarySlider = new Splide(el, this.configuration(el));
    }

    if (pagination || page) {
      primarySlider.on('pagination:updated', (data) => {
        data.items.forEach((item, index) => {
          if (item.button && item.li) {
            if (item.button.classList.contains('is-active')) {
              item.li.classList.add('is-active');
              if (navButtons) navButtons[index].classList.add('is-active');

              if (page) {
                page.innerText = index + 1;
              }
            } else {
              item.li.classList.remove('is-active')
              if (navButtons) navButtons[index].classList.remove('is-active');
            }
          }
        });
      });
    }

    if (slider.dataset.navButtonsId) {
      navButtons = document.querySelectorAll(`#${slider.dataset.navButtonsId} button`);

      navButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
          primarySlider.go(index);
        });
      });
    }

    if (sliderNav) {
      thumbnails = sliderNav.querySelectorAll('.js-slider-thumbnail');
  
      thumbnails.forEach((el, index) => {
        el.addEventListener('click', () => {
          primarySlider.go(index);
        });
      });
    }

    function calculateProgress(slider) {
      const lastVisible = getSlides(slider).lastVisible.index + 1;
      const totalSlides = getSlides(slider).totalSlides;

      if (lastVisible !== 0) {
        const progress = 100 / (totalSlides / lastVisible);

        if (progressBar) {
          progressBar.style.width = `${progress}%`;
        }
      }
    }

    function getSlides(slider) {
      const slides = slider.querySelectorAll('.js-slider-slide');
      let lastVisible = { index: 0 }; 

      for (let j = slides.length - 1; j > 0; j--) {
        if (slides[j].classList.contains('is-visible')) {
          lastVisible.index = j;
          break;
        }
      }

      return {
        lastVisible,
        totalSlides: slides.length
      }
    }

    if (slider.getAttribute('data-product-main-slider')) {
      document.addEventListener('slider:go', (e) => {
        const index = e.detail.index;
        const targetSliders = e.detail.targetSliders;
        let goTo = false;

        targetSliders.forEach((el) => {
          if (el.id == slider.id) {
            goTo = true
          }
        });

        if (goTo) {
          primarySlider.go(index - 1);
        }
      });
    }

    if (Shopify.designMode) {
      document.addEventListener('sliders:destroy', () => {
        primarySlider.destroy();

        if (secondarySlider) {
          secondarySlider.destroy();
        }
      });
    }

    primarySlider.mount();

    if (secondarySlider) {
      secondarySlider.mount();
    }
  }

  configuration(el){
    let breakpointsObject = {
      519: {},
      749: {},
      979: {},
      1279: {},
      1399: {},
      1599: {}
    },
    breakpointsList = [],
    sliderPerPage = 0,
    sliderPerPageXs = el.getAttribute('data-slider-perpage-xs'),
    sliderPerPagePh = el.getAttribute('data-slider-perpage-ph'),
    sliderPerPageSm = el.getAttribute('data-slider-perpage-sm'),
    sliderPerPageMd = el.getAttribute('data-slider-perpage-md'),
    sliderPerPageLg = el.getAttribute('data-slider-perpage-lg'),
    sliderPerPageXl = el.getAttribute('data-slider-perpage-xl'),
    sliderPerMoveXs = el.getAttribute('data-slider-permove-xs'),
    sliderPerMovePh = el.getAttribute('data-slider-permove-ph'),
    sliderPerMoveSm = el.getAttribute('data-slider-permove-sm'),
    sliderPerMoveMd = el.getAttribute('data-slider-permove-md'),
    sliderPerMoveLg = el.getAttribute('data-slider-permove-lg'),
    sliderPerMoveXl = el.getAttribute('data-slider-permove-xl'),
    sliderAutoWidthSm = el.getAttribute('data-slider-autowidth-sm'),
    sliderGapSm = el.getAttribute('data-slider-gap-sm'),
    sliderPhOnly = el.getAttribute('data-slider-ph-only'),
    sliderSmOnly = el.getAttribute('data-slider-sm-only'),
    sliderMdOnly = el.getAttribute('data-slider-md-only'),
    sliderLgOnly = el.getAttribute('data-slider-lg-only'),
    sliderPadding = el.getAttribute('data-slider-padding'),
    sliderPaddingObject = {};

    if (sliderPerPageXs) {
      breakpointsObject['519'].perPage = sliderPerPageXs;
    }

    if (sliderPerPagePh) {
      breakpointsObject['749'].perPage = sliderPerPagePh;
    }

    if (sliderPerPageSm) {
      breakpointsObject['979'].perPage = sliderPerPageSm;
    }

    if (sliderPerPageMd) {
      breakpointsObject['1279'].perPage = sliderPerPageMd;
    }

    if (sliderPerPageLg) {
      breakpointsObject['1399'].perPage = sliderPerPageLg;
    }

    if (sliderPerPageXl) {
      breakpointsObject['1599'].perPage = sliderPerPageXl;
    }

    if (sliderAutoWidthSm) {
      breakpointsObject['979'].autoWidth = (sliderAutoWidthSm === "true");
    }

    if (sliderPerMoveXs) {
      breakpointsObject['519'].perMove = sliderPerMoveXs;
    }

    if (sliderPerMovePh) {
      breakpointsObject['749'].perMove = sliderPerMovePh;
    }

    if (sliderPerMoveSm) {
      breakpointsObject['979'].perMove = sliderPerMoveSm;
    }

    if (sliderPerMoveMd) {
      breakpointsObject['1279'].perMove = sliderPerMoveMd;
    }
    
    if (sliderPerMoveLg) {
      breakpointsObject['1399'].perMove = sliderPerMoveLg;
    }

    if (sliderPerMoveXl) {
      breakpointsObject['1599'].perMove = sliderPerMoveXl;
    }

    if (sliderGapSm) {
      breakpointsObject['979'].gap = sliderGapSm;
    }

    if (sliderPhOnly) {
      breakpointsObject['749'].destroy = false;
    }

    if (sliderSmOnly) {
      breakpointsObject['979'].destroy = false;
    }

    if (sliderMdOnly) {
      breakpointsObject['1279'].destroy = false;
    }

    if (sliderLgOnly) {
      breakpointsObject['1399'].destroy = false;
    }

    if (el.getAttribute('data-slider-perpage')){
      sliderPerPage = el.getAttribute('data-slider-perpage');
    } else {
      sliderPerPage = 1;
    }

    if (sliderPadding) {
      const splitPadding = sliderPadding.split(",");

      splitPadding.forEach(function (value, index) {
        switch(index) {
          case 0:
            Object.assign(sliderPaddingObject, {top: value});
            break;
          case 1:
            Object.assign(sliderPaddingObject, {right: value});
            break;
          case 2:
            Object.assign(sliderPaddingObject, {bottom: value});
          break;
          case 3:
            Object.assign(sliderPaddingObject, {left: value});
          break;
        }
      });
    } else {
      sliderPaddingObject = false;
    }

    // Each sliders config
    let conf = {
      type: el.getAttribute('data-slider-type') || "carousel",
      rewind: el.getAttribute('data-slider-rewind') || false,
      speed: el.getAttribute('data-slider-speed') || 400,
      rewindSpeed: el.getAttribute('data-slider-rewindspeed') || 0,
      waitForTransition: el.getAttribute('data-slider-waitfortransition') || true,
      width: el.getAttribute('data-slider-width') || 0,
      height: el.getAttribute('data-slider-height') || 0,
      fixedWidth: el.getAttribute('data-slider-fixedwidth') || 0,
      fixedHeight: el.getAttribute('data-slider-fixedheight') || 0,
      heightRatio: el.getAttribute('data-slider-heightratio') || 0,
      autoWidth: el.getAttribute('data-slider-autowidth') || false,
      autoHeight: el.getAttribute('data-slider-autoheight') || false,
      perPage: el.getAttribute('data-slider-perpage') || 0,
      perMove: el.getAttribute('data-slider-permove') || 0,
      clones: el.getAttribute('data-slider-clones') || 0,
      start: el.getAttribute('data-slider-start') || 0,
      focus: el.getAttribute('data-slider-focus') || 0,
      gap: el.getAttribute('data-slider-gap') || 0,
      padding: sliderPaddingObject,
      easing: el.getAttribute('data-slider-easing') || 'cubic-bezier(.42,.65,.27,.99)',
      arrows: el.getAttribute('data-slider-arrows') || false,
      pagination: el.getAttribute('data-slider-pagination') || false,
      autoplay: el.getAttribute('data-slider-autoplay') || false,
      interval: el.getAttribute('data-slider-interval') || 5000,
      pauseOnHover: el.getAttribute('data-slider-pauseonhover') || true,
      pauseOnFocus: el.getAttribute('data-slider-pauseonfocus') || true,
      resetProgress: el.getAttribute('data-slider-resetprogress') || true,
      lazyload: el.getAttribute('data-slider-lazyload') || false,
      preloadPages: el.getAttribute('data-slider-preloadpages') || 1,
      keyboard: el.getAttribute('data-slider-keyboard') === 'false' ? false : 'global',
      drag: el.getAttribute('data-slider-drag') === 'false' ? false : true,
      flickPower: el.getAttribute('data-slider-flickpower') || 600,
      flickMaxPages: el.getAttribute('data-slider-flickmaxpages') || 1,
      direction: el.getAttribute('data-slider-direction') || 'ltr',
      cover: el.getAttribute('data-slider-cover') || false,
      slideFocus: el.getAttribute('data-slider-slidefocus') || true,
      isNavigation: el.getAttribute('data-slider-isnavigation') || false,
      trimSpace: el.getAttribute('data-slider-trimspace') || true,
      updateOnMove: el.getAttribute('data-slider-updateonmove') || false,
      destroy: el.getAttribute('data-slider-disabled') || false,
      omitEnd: el.getAttribute('data-slider-omitend') || false,
      noDrag: el.getAttribute('data-slider-nodrag') || '',
      breakpoints: breakpointsObject
    }
    return conf;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Slider();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    const blogCarouselSliders = document.querySelectorAll('.js-blog-carousel');

    document.dispatchEvent(new Event('sliders:destroy'));
    
    new Slider();

    document.dispatchEvent(new Event('asyncSlider:ready'));

    blogCarouselSliders.forEach((el) => {
      document.dispatchEvent(new CustomEvent('blogCarouselSlider:ready', {
        detail: {
          id: el.id
        }
      }));
    });
  });

  document.addEventListener('shopify:block:deselect', () => {
    const blogCarouselSliders = document.querySelectorAll('.js-blog-carousel');

    document.dispatchEvent(new Event('sliders:destroy'));

    new Slider();

    document.dispatchEvent(new Event('asyncSlider:ready'));

    blogCarouselSliders.forEach((el) => {
      document.dispatchEvent(new CustomEvent('blogCarouselSlider:ready', {
        detail: {
          id: el.id
        }
      }));
    });
  });
}
